export { isTeamsAppEnabled } from '../src/isTeamsAppEnabled.ts';
